import { render, staticRenderFns } from "./ModalRetencaoContaB.vue?vue&type=template&id=05b3d0d4&scoped=true"
import script from "./ModalRetencaoContaB.vue?vue&type=script&lang=js"
export * from "./ModalRetencaoContaB.vue?vue&type=script&lang=js"
import style0 from "./ModalRetencaoContaB.vue?vue&type=style&index=0&id=05b3d0d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b3d0d4",
  null
  
)

export default component.exports